// release = 1 || development = 0.
// Derived from the build itself: `npm start` sets NODE_ENV=development,
// `npm run build` sets production. Nothing to toggle by hand, so a production
// build can never ship with dev URLs, or vice versa.
const profile = process.env.NODE_ENV === "production" ? 1 : 0;

// Host and scheme always come from the page the app was loaded from, so one
// build works anywhere: on a bare IP over http, or on the real domain over
// https once DNS and TLS are in place - with no rebuild and no redeploy.
// The MQTT websocket follows too (see mqtt/mqtt.js): https gives wss, http ws.
const appdomain = window.location.hostname;
const appprotocol = window.location.protocol.replace(":", "");

const backendport = "3001";
const frontendport = "3000";

// profile selects the URL shape, not the host. In release everything is one
// origin behind Apache, which proxies /Surf, /api and /ws/. In development
// there is no proxy, so each piece is on its own port on the same host.
const frontend_app_url =
  appprotocol + "://" + appdomain + (profile ? "/Surf" : ":" + frontendport);

const backend_app_url =
  appprotocol + "://" + appdomain + (profile ? "/api" : ":" + backendport);

const companyconstantpartofmac = "0-1f-13-";

module.exports = {
  appdomain,
  appprotocol,
  backendport,
  frontendport,
  frontend_app_url,
  backend_app_url,
  companyconstantpartofmac,
  profile,
};
